import {useEffect, useRef} from 'react';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {usePathname} from 'coreHooks';

type TUseLockedBodyOutputArgs = {
	initialLocked?: boolean;
	rootId?: string;
	lockerClassName?: string;
	restoreScrollPosition?: boolean;
	delay?: number;
};
type TUseLockedBodyOutputReturn = {isScrollLocked: () => boolean; lockScroll: (newValue: boolean) => void};

const DEFAULT_PARAMS = {
	initialLocked: false,
	rootId: 'app-main',
	lockerClassName: 'lock-scroll',
	restoreScrollPosition: false,
	delay: 0,
};

const useLockScroll = ({
	initialLocked = DEFAULT_PARAMS.initialLocked,
	rootId = DEFAULT_PARAMS.rootId,
	lockerClassName = DEFAULT_PARAMS.lockerClassName,
	restoreScrollPosition = DEFAULT_PARAMS.restoreScrollPosition,
	delay = DEFAULT_PARAMS.delay,
}: TUseLockedBodyOutputArgs = DEFAULT_PARAMS): TUseLockedBodyOutputReturn => {
	const {managerRepository} = useGeneralProvider();
	const pathname = usePathname();
	const lockedRef = useRef(false);

	useEffect(() => {
		managerRepository.getUiMgr().resetLockScrollSavedCoords(lockerClassName, rootId);
	}, [pathname]);

	useEffect(() => {
		return () => {
			if (lockedRef.current) {
				managerRepository.getUiMgr().unlockScroll(lockerClassName, rootId, restoreScrollPosition, 0);
			}
		};
	}, []);

	if (initialLocked) {
		managerRepository.getUiMgr().lockScroll(lockerClassName, rootId, restoreScrollPosition);
		lockedRef.current = true;
	}

	return {
		isScrollLocked: () => {
			return (managerRepository.getUiMgr().isScrollLocked as any)(lockerClassName, rootId, restoreScrollPosition);
		},
		lockScroll: (lock) => {
			lockedRef.current = lock;

			if (lock) {
				managerRepository.getUiMgr().lockScroll(lockerClassName, rootId, restoreScrollPosition, delay);
			} else {
				managerRepository.getUiMgr().unlockScroll(lockerClassName, rootId, restoreScrollPosition, delay);
			}
		}
	};
};

export default useLockScroll;
